import React from "react";
import PropTypes from "prop-types";
import { addWithoutAdsToTemplates } from "../get-collection-template";
import { LazyCollection } from "@quintype/components";
import { GA, WebEngage, DeepBI, PGAD } from "../../integrations";
import styles from "./audio-magazine.m.css";
const newTemplates = addWithoutAdsToTemplates("home");
function getAdsWrappedCollectionTemplate(designTemplate, index) {
  if (index >= 3) {
    return newTemplates["digital-ebook-collection-1"];
  }
  return newTemplates[`audio-collection-${index}`];
}

export class EbookMagazinePage extends React.Component {
  constructor() {
    super();
    this.state = { filter: null, currentIndex: 0, action: false };
    this.iframeWidgetsRef = React.createRef();
    this.pointtableWidgetsRef = React.createRef();
    this.StoryCollectionWidgetsRef = React.createRef();
  }
  componentDidMount() {
    GA.registerPageView(this.props.pageType, {});
    WebEngage.registerPageView();
    DeepBI.registerPageView({ collection: this.props });
    PGAD.loadScript();
  }

  render() {
    return (
      <React.Fragment>
        <div className={styles["audio-magazine-main-page"]}>
          <div className={`js-story-main-container ${`${styles["base"]}`}`}>
            <div className={`${styles["audio-magazine-page-container"]} container`}>
              <div ref={this.StoryCollectionWidgetsRef} className={styles["page-space"]}>
                <h1 className={styles["page-title"]}>Tamil Audio Books</h1>
                <LazyCollection
                  collection={this.props.data.collection}
                  config={this.props.config}
                  collectionTemplates={getAdsWrappedCollectionTemplate}
                  lazyAfter={3}
                  accentColor={"#2f81cd"}
                  pageType={"Audio Magazine"}
                />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

EbookMagazinePage.propTypes = {
  data: PropTypes.shape({
    collection: PropTypes.object,
    magazine: PropTypes.array
  }),
  pageType: PropTypes.string,
  config: PropTypes.shape({
    disableAds: PropTypes.bool,
    contentInsightsId: PropTypes.string
  }),
  collection: PropTypes.shape({
    items: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.string
      })
    ).isRequired
  }).isRequired
};
